/* eslint-disable max-lines */
/* eslint-disable max-len */

export function ContentLocaleNl() {
  return (
    <>
      <div>
        <p className="page-title">Privacybeleid van het Robotics Web Portal</p>
        <h2 className="heading-title">
          I. Naam en adres van de verwerkingsverantwoordelijke en de
          functionaris gegevensbescherming
        </h2>

        <p className="my-20">
          Naam en contactgegevens van de verwerkingsverantwoordelijke:
        </p>
        <p>Kärcher NV</p>
        <p>Kees Wagtmans (directeur)</p>
        <p>Boomsesteenweg 939,</p>
        <p>2610 Wilrijk</p>
        <p>Tel.: 03 340 08 00</p>
        <p>
          <a href="mailto:info@be.kaercher.com">info@be.kaercher.com</a>
        </p>

        <p className="my-10">
          (hierna: ‘Kärcher’) voert alle gegevensverwerkingshandelingen uit
          (waaronder het verzamelen, verwerken en doorgeven van gegevens)
          overeenkomstig de wettelijke voorschriften.
        </p>

        <p className="my-10">
          Dit Privacybeleid geeft u een overzicht van de soort gegevens die op
          en via ons webportaal&nbsp;
          <a
            href="https://kira-webportal.ipp.kaercher.com/"
            target="_blank"
            rel="noreferrer noopener">
            https://kira-webportal.ipp.kaercher.com/
          </a>
          &nbsp;(hierna: het ‘platform’) worden verzameld, hoe de gegevens
          worden verwerkt, welke beveiligingsmaatregelen Kärcher neemt om uw
          gegevens te beschermen en hoe u uw rechten kunt uitoefenen.
        </p>

        <p className="my-10">
          Indien u vragen heeft met betrekking tot gegevensbescherming of uw
          rechten als betrokkene kunt u contact opnemen met de functionaris
          gegevensbescherming van Kärcher als volgt:
        </p>

        <p>Kärcher NV</p>
        <p>Functionaris gegevensbescherming</p>
        <p>Boomsesteenweg 939,</p>
        <p>2610 Wilrijk</p>
        <p>
          <a href="mailto:dpo@be.kaercher.com">dpo@be.kaercher.com</a>
        </p>
      </div>

      <div className="mt-40">
        <h2>II. Algemene informatie over gegevensverwerking</h2>

        <h3>1. Reikwijdte verwerking persoonsgegevens</h3>
        <p>
          Tenzij anders vermeld, verwerken wij de persoonsgegevens van u, de
          gebruiker van ons platform (hierna: ‘betrokkene’), om u een
          functioneel en gebruikersvriendelijk platform en onze gerelateerde
          diensten te kunnen verstrekken en leveren.
        </p>

        <h3>2. Rechtsgronden voor de verwerking van persoonsgegevens</h3>
        <p>
          Voor zover wij van de betrokkene toestemming krijgen voor het
          verwerken van persoonsgegevens, dient artikel 6, lid 1, onder a van de
          Algemene verordening gegevensbescherming (AVG) als rechtsgrond voor de
          verwerking.
        </p>

        <p className="mt-10">
          Als de verwerking van persoonsgegevens noodzakelijk is voor gebruik
          van het platform, dient artikel 6, lid 1, onder b AVG als rechtsgrond
          voor de verwerking. Dit geldt ook voor verwerkingsactiviteiten die
          noodzakelijk zijn voor de implementatie van precontractuele
          maatregelen.
        </p>
        <p>
          Voor zover de verwerking van persoonsgegevens noodzakelijk is voor het
          nakomen van een wettelijke verplichting waar onze onderneming aan moet
          voldoen, dient artikel 6, lid 1, onder c AVG als rechtsgrond voor de
          verwerking.
        </p>

        <p className="mt-10">
          Indien de verwerking noodzakelijk is voor de bescherming van een
          gerechtvaardigd belang van onze onderneming of een externe partij en
          mits de belangen, fundamentele rechten en vrijheden van de betrokkene
          niet zwaarder wegen dan de eerdergenoemde belangen, dient artikel 6,
          lid 1, onder f AVG als rechtsgrond voor de verwerking.
        </p>

        <h3>3. Gegevensverwijdering en bewaartermijn</h3>
        <p>
          Tenzij anders vermeld, worden persoonsgegevens geblokkeerd of
          verwijderd zodra het doel van de bewaring niet langer van toepassing
          is.
        </p>

        <p className="mt-10">
          Gegevens kunnen worden bewaard indien daarin is voorzien door de
          Europese of nationale wetgever in EU-regelgeving, wetgeving of andere
          bepalingen waaraan de verwerkingsverantwoordelijke is onderworpen.
          Persoonsgegevens worden eveneens geblokkeerd of verwijderd indien een
          voorgeschreven bewaartermijn verloopt, tenzij verdere bewaring van de
          gegevens noodzakelijk is voor afronding of uitvoering van een
          contract.
        </p>
      </div>

      <div className="mt-40">
        <h2>III. Levering van het platform</h2>

        <h3>1. Beschrijving en reikwijdte van gegevensverwerking</h3>
        <p>
          Telkens wanneer iemand toegang verkrijgt tot ons platform, verzamelt
          ons systeem automatisch gegevens en informatie van het computersysteem
          dat de toegang heeft aangevraagd.
        </p>

        <p className="mt-10">Daarbij worden de volgende gegevens verzameld:</p>

        <ul>
          <li>datum en tijd van de aanvraag</li>
          <li>naam van het opgevraagde bestand</li>
          <li>tijdstip van laatste aanmelding</li>
          <li>pagina waarvandaan het bestand werd opgevraagd</li>
          <li>
            toegangsstatus (bestand doorgegeven, bestand niet gevonden e.d.)
          </li>
          <li>gebruikt(e) webbrowser en besturingssysteem</li>
          <li>volledig IP-adres van de aanvragende computer</li>
          <li>hoeveelheid doorgestuurde gegevens</li>
          <li>Robotics-gegevens, robotroute-informatie en kaarten</li>
        </ul>

        <p>
          De gegevens worden eveneens bewaard in de logbestanden in ons systeem.
        </p>

        <h3>2. Rechtsgrond voor gegevensverwerking</h3>
        <p>
          De rechtsgrond voor de tijdelijke bewaring van de gegevens en
          logbestanden is artikel 6, lid 1, onder f AVG.
        </p>

        <h3>3. Doel van de gegevensverwerking</h3>
        <p>
          Tijdelijke bewaring van het IP-adres door het systeem is noodzakelijk
          voor levering van het platform aan de computer van de gebruiker. Voor
          dit doel moet het IP-adres van de gebruiker bewaard blijven voor de
          duur van de sessie.
        </p>

        <p className="mt-10">
          Bewaring in logbestanden vindt plaats om de functionaliteit van het
          platform te verzekeren. Daarnaast gebruiken wij de gegevens om het
          platform te optimaliseren en beveiliging van onze IT-systemen te
          waarborgen.
        </p>

        <p className="mt-10">
          Deze doeleinden vormen ook ons gerechtvaardigd belang bij de
          verwerking van persoonsgegevens krachtens artikel 6, lid 1, onder f
          AVG.
        </p>

        <h3>4. Bewaartermijn</h3>
        <p>
          De gegevens worden verwijderd zodra ze niet langer noodzakelijk zijn
          voor het doel waarvoor ze werden verzameld.
        </p>
      </div>

      <div className="mt-40">
        <h2>IV. Registratie op het platform</h2>

        <h3>1. Beschrijving en reikwijdte van gegevensverwerking</h3>
        <p>
          Voor een uitgebreid gebruik van het platform en voor het ophalen van
          de machinegegevens die zijn verwerkt voor het/de betreffende
          geregistreerde apparaat/apparaten is registratie op het platform en
          van een gebruikersaccount verplicht.
        </p>

        <p className="mt-10">
          De registratie van een gebruikersaccount vindt plaats via een
          Kärcher-account, waarbij gebruikers een wachtwoord kunnen selecteren
          dat wordt gebruikt in combinatie met hun e-mailadres (hierna:
          ‘gebruikersgegevens’). Daarnaast kan vrijwillig aanvullende informatie
          (bijv. bedrijfsnaam en contactgegevens) worden verstrekt. De gegevens
          worden ingevoerd in een invoermasker, aan ons opgestuurd en door ons
          bewaard.
        </p>

        <p className="mt-10">
          Telefoonnummers en e-mailadressen kunnen op het platform worden
          bewaard voor het doorsturen van berichten via sms of vanaf een
          apparaat verzonden e-mails. Deze gegevens worden bewaard als
          zogenaamde operators en het gaat daarbij om de naam, het
          telefoonnummer, het e-mailadres en het desbetreffende apparaat
          waarvandaan de berichten worden doorgestuurd.
        </p>

        <h3>2. Rechtsgrond voor gegevensverwerking</h3>
        <p>
          De rechtsgrond voor de verwerking van persoonsgegevens ligt in de
          uitvoering van een overeenkomst (artikel 6, lid 1, onder b AVG).
        </p>

        <h3>3. Doel van de gegevensverwerking</h3>
        <p>
          Het aanmaken van een gebruikersaccount is eveneens noodzakelijk voor
          toewijzing aan het betreffende apparaat of gebruik van de verschafte
          functies. De gegevens kunnen derhalve ook worden verwerkt wanneer de
          door de gebruiker geselecteerde functies worden gebruikt.
        </p>

        <h3>4. Bewaartermijn</h3>
        <p>
          Wanneer u een gebruikersaccount aanmaakt, bewaren wij in het algemeen
          de persoonsgegevens gedurende de periode waarin u uw gebruikersaccount
          handhaaft of totdat de gegevens in het gebruikersaccount worden
          gewijzigd of verwijderd.
        </p>

        <p className="mt-10">
          Wij wijzen erop dat verwijdering van het betreffende gebruikersaccount
          van het platform kan leiden tot verlies van toegang tot het platform
          en tot de bewaarde gegevens.
        </p>

        <h3>5. Mogelijkheid van verwijdering</h3>
        <p>
          Gebruikers van het platform hebben te allen tijde de mogelijkheid om
          de aldaar bewaarde persoonsgegevens te wijzigen of verwijderen.
        </p>

        <p className="mt-10">
          Als de gegevens benodigd zijn voor de uitvoering van een overeenkomst
          of de implementatie van precontractuele maatregelen, is vroegtijdige
          verwijdering van de gegevens uitsluitend mogelijk voor zover
          contractuele of wettelijke verplichtingen die verwijdering niet
          beletten.
        </p>
      </div>

      <div className="mt-40">
        <h2>V. Gebruik van cookies</h2>

        <h3>1. Beschrijving en reikwijdte van gegevensverwerking</h3>
        <p>
          Ons platform maakt gebruik van cookies. Cookies zijn tekstbestanden
          die worden opgeslagen in de internetbrowser, of door de
          internetbrowser worden opgeslagen in het computersysteem van de
          gebruiker. Wanneer een gebruiker een platform opent, kan een cookie op
          zijn of haar besturingssysteem worden opgeslagen. Dit cookie bevat een
          specifieke tekenreeks die unieke identificatie van de browser mogelijk
          maakt wanneer het platform later opnieuw wordt geopend.
        </p>

        <h3>2. Rechtsgrond voor gegevensverwerking</h3>
        <p>
          De rechtsgrond voor de verwerking van persoonsgegevens met gebruik van
          functionele of technisch noodzakelijke cookies is artikel 6, lid 1,
          onder f AVG.
        </p>

        <h3>3. Doel van de gegevensverwerking</h3>
        <p>
          Het gebruik van technisch noodzakelijke cookies heeft tot doel het
          gebruik van het platform voor gebruikers te vereenvoudigen. Sommige
          functies van ons platform kunnen zonder gebruik van cookies niet
          worden aangeboden. De door technisch noodzakelijke cookies verzamelde
          gebruikersgegevens worden niet gebruikt om gebruikersprofielen aan te
          maken. Deze doeleinden vormen tevens ons gerechtvaardigd belang voor
          de verwerking van persoonsgegevens krachtens artikel 6, lid 1, onder f
          AVG.
        </p>

        <h3>4. Mogelijkheid van bezwaar</h3>
        <p>
          Cookies worden opgeslagen op de computer van de gebruiker en van
          daaruit doorgestuurd naar onze site. Als gebruiker heeft u zo de
          volledige controle over het gebruik van cookies. Door de instellingen
          in uw internetbrowser te wijzigen, kunt u de doorgifte van cookies
          uitschakelen of beperken. Cookies die reeds zijn opgeslagen, kunnen op
          elk gewenst moment worden verwijderd. Dergelijke verwijdering kan ook
          worden geautomatiseerd. Het deactiveren van cookies voor ons platform
          kan ertoe leiden dat niet alle functies op het platform nog volledig
          kunnen worden gebruikt.
        </p>
      </div>

      <div className="mt-40">
        <h2>VI. Bekendmaking aan derden</h2>

        <p>
          Binnen de bedrijven van de Kärcher-groep wisselen we persoonsgegevens
          uit voor zover en in de mate waarin dat noodzakelijk is voor de
          verwerking van overeenkomsten of de implementatie van precontractuele
          maatregelen. Dit gebeurt overeenkomstig artikel 6, lid 1, onder b AVG
          of, als een gerechtvaardigd belang doorgifte binnen de groep
          noodzakelijk maakt, overeenkomstig artikel 6, lid 1, onder f AVG.
        </p>

        <p className="mt-10">
          Naast de expliciet in dit Privacybeleid genoemde gevallen zal
          doorgifte van uw persoonsgegevens aan derden zonder uw uitdrukkelijke
          toestemming uitsluitend plaatsvinden indien dit wettelijk is
          toegestaan of vereist.
        </p>

        <p className="mt-10">
          Indien noodzakelijk voor opheldering van onwettig gebruik of misbruik
          van het platform of voor rechtsvervolgingsdoeleinden, zullen
          persoonsgegevens worden doorgegeven aan rechtshandhavingsinstanties of
          andere autoriteiten en, waar nodig, aan benadeelde derden. Dit gebeurt
          echter alleen wanneer er een indicatie is van onrechtmatig gedrag of
          misbruik. Daarnaast hebben wij de wettelijke plicht om desgevraagd
          informatie te verstrekken aan bepaalde overheidsinstanties. Het gaat
          daarbij om rechtshandhavingsinstanties die overtredingen vervolgen
          waarvoor boetes kunnen worden opgelegd, evenals belastingdiensten.
        </p>

        <p className="mt-10">
          De bekendmaking van persoonsgegevens wordt gerechtvaardigd door het
          feit dat (1) krachtens artikel 6, lid 1, onder c AVG in samenhang met
          nationale wettelijke vereisten betreffende de bekendmaking van
          gegevens aan rechtshandhavingsinstanties de verwerking noodzakelijk is
          voor naleving van een op ons rustende wettelijke verplichting of (2)
          wij een gerechtvaardigd belang hebben bij het verstrekken van de
          gegevens aan de eerdergenoemde partijen in geval van indicaties van
          misbruik of voor de uitoefening van rechtsvorderingen en mits
          overeenkomstig artikel 6, lid 1, onder f AVG uw rechten en belangen
          bij de bescherming van uw persoonsgegevens niet zwaarder wegen dan ons
          gerechtvaardigd belang.
        </p>

        <p className="mt-10">
          Teneinde de diensten op dit platform te kunnen aanbieden, wordt
          gebruikgemaakt van externe bedrijven en dienstverleners. Dergelijke
          externe bedrijven en dienstverleners worden zorgvuldig geselecteerd
          als verwerkers binnen de reikwijdte van artikel 28, lid 1 AVG,
          regelmatig gecontroleerd en contractueel verplicht tot verwerking van
          de persoonsgegevens niet anders dan volgens onze instructies.
        </p>
      </div>

      <div className="mt-40">
        <h2>VII. Doorgifte van gegevens aan derde landen </h2>

        <p>
          Tenzij anders vermeld, worden gegevens uitsluitend doorgegeven aan
          organen in landen buiten de Europese Unie (zogenaamde derde landen)
          indien:
        </p>

        <ul>
          <li>
            dat noodzakelijk is voor de uitvoering van uw opdrachten (bijv.
            betalingsopdrachten);
          </li>
          <li>dat dient om het product te verbeteren;</li>
          <li>een passend niveau van gegevensbescherming is gewaarborgd;</li>
          <li>u ons toestemming heeft gegeven om dat te doen.</li>
        </ul>
      </div>

      <div className="mt-40">
        <h2>VIII. Gegevensbescherming</h2>

        <h3>1. Algemene technische en organisatorische maatregelen</h3>
        <p>
          Kärcher heeft verschillende beveiligingsmaatregelen genomen om
          persoonsgegevens adequaat en in gepaste mate te beschermen. Alle door
          Kärcher opgeslagen gegevens worden beschermd door fysieke, technische
          en procedurele maatregelen die toegang tot de gegevens beperken tot
          specifiek daartoe gemachtigde personen overeenkomstig dit
          Privacybeleid.
        </p>

        <h3>2. Veilige gegevensdoorgifte</h3>
        <p>
          Tijdens de doorgifte van uw persoonsgegevens in samenhang met een
          orderprocedure worden die gegevens versleuteld met behulp van de
          standaard technologie Secure Socket Layer (‘SSL’) in een
          SSL-versleutelde versie, of vergelijkbare technologie.
        </p>

        <h3>3. Wachtwoorden</h3>
        <p>
          U mag uw wachtwoord voor toegang tot ons platform nooit doorgeven aan
          derden en u moet het ook regelmatig wijzigen. Bij het verlaten van uw
          gebruikersaccount moet u altijd uitloggen en uw browser sluiten om
          eventuele onbevoegde toegang te voorkomen.
        </p>
      </div>

      <div className="mt-40">
        <h2>IX. Rechten van de betrokkene</h2>

        <h3>1. Recht op inzage</h3>
        <p>
          Krachtens artikel 15 van de AVG kunt u vragen om inzage in de
          persoonsgegevens die wij van u verwerken.
        </p>

        <h3>2. Recht van bezwaar</h3>
        <p>
          Op bepaalde gronden heeft u het recht bezwaar te maken tegen
          verwerking van uw gegevens (zie punt 8).
        </p>

        <h3>3. Recht op rectificatie</h3>
        <p>
          Indien de informatie met betrekking tot u niet of niet langer juist
          is, kunt u om rectificatie verzoeken ingevolge artikel 16 AVG. Als uw
          gegevens onvolledig zijn, kunt u verzoeken dat de gegevens volledig
          worden gemaakt.
        </p>

        <h3>4. Recht op wissing</h3>
        <p>
          Ingevolge artikel 17 AVG kunt u verzoeken om de wissing van uw
          persoonsgegevens.
        </p>

        <h3>5. Recht op beperking van de verwerking</h3>
        <p>
          Ingevolge artikel 18 AVG heeft u het recht te verzoeken om beperking
          van de verwerking van uw persoonsgegevens.
        </p>

        <h3>6. Recht om een klacht in te dienen</h3>
        <p>
          Als u van mening bent dat de verwerking van uw persoonsgegevens in
          strijd is met gegevensbeschermingswetgeving, heeft u overeenkomstig
          artikel 77, lid 1 AVG het recht om een klacht in te dienen bij een
          toezichthoudende autoriteit van uw keuze of bij de toezichthoudende
          autoriteit die verantwoordelijk is voor de gegevensverwerker.
        </p>

        <h3>7. Recht op overdraagbaarheid van gegevens</h3>
        <p>
          Indien wordt voldaan aan de vereisten van artikel 20, lid 1 AVG, heeft
          u het recht de gegevens die wij op basis van uw toestemming of ter
          uitvoering van een overeenkomst verwerken, te laten overdragen aan u
          of een derde.
        </p>

        <h3>8. Recht van bezwaar krachtens artikel 21, lid 1 AVG</h3>
        <p>
          U heeft te allen tijde het recht om op grond van met uw specifieke
          situatie verband houdende redenen bezwaar te maken tegen de op basis
          van artikel 6, lid 1, onder f AVG uitgevoerde verwerking van uw
          persoonsgegevens. In dat geval zal de verwerkingsverantwoordelijke de
          verwerking van de persoonsgegevens staken, tenzij hij/zij dwingende
          gerechtvaardigde gronden voor de verwerking kan aanvoeren die zwaarder
          wegen dan de belangen, rechten en vrijheden van de betrokkene of die
          verband houden met de instelling, uitoefening of onderbouwing van een
          rechtsvordering.
        </p>
      </div>

      <div className="mt-40">
        <h2>X. Wijzigingen in dit Privacybeleid</h2>

        <p>
          Wij zorgen dat dit Privacybeleid actueel wordt gehouden. Om die reden
          behouden wij ons het recht voor om het van tijd tot tijd bij te werken
          en aan te passen en er eventuele wijzigingen in de verwerking of het
          gebruik van uw gegevens in op te nemen. De actuele versie van ons
          Privacybeleid is steeds beschikbaar op het platform, onder
          ‘Privacybeleid’.
        </p>
      </div>
    </>
  );
}
